import { InspectorControls } from "@wordpress/block-editor";
import { PanelBody, ToggleControl, TextControl } from "@wordpress/components";
import { t } from "drupal";
import { debug } from '../../utilities/helpers';


function AccordionItemSidePanel({
  attributes,
  title = "",
  onChangeTitle = () => {},
  setAttributes }) {
  const { isOpen = false } = attributes;

  const toggleOpen = () => {
    setAttributes({ isOpen: !isOpen });
  };

  // debug("Accordion Child - Side Panel", { title, isOpen });


  return (
    <InspectorControls>
      <PanelBody title={t("Accordion Item Settings")} initialOpen>
        <ToggleControl
          label={t("Open by default?")}
          checked={isOpen}
          onChange={toggleOpen}
        />

        <TextControl
          label={t("Accordion Title")}
          value={title}
          placeholder={t("Accordion Title")}
          onChange={onChangeTitle}
        />

      </PanelBody>
    </InspectorControls>
  );
}

export default AccordionItemSidePanel;
